import { instance } from '@/services/avik-api-gateway'
import { VehicleTypeGroupPeriod } from '@/types/vehicle-type-group-period'
import { AxiosResponse } from 'axios'

export function updateVehicleTypeGroupPeriod(
  body: VehicleTypeGroupPeriod
): Promise<AxiosResponse<VehicleTypeGroupPeriod>> {
  return instance.put(`/vehicle-type-group-period/${body.uuid}`, body)
}
